export function setCookie(name: string, value: string, cookieDuration: number | null) {
  let expires = '';
  if (cookieDuration) {
    const cookieExpireDate = new Date(Date.now() + cookieDuration * 1000);
    expires = `;expires=${cookieExpireDate.toUTCString()}`;
  }
  document.cookie = `${name}=${value};path=/;secure${expires}`;
}

export function getCookie(name: string) {
  const namePrefix = name + "=";
  const value = document.cookie
    .split(';')
    .map(c => c.trim())
    .find(c => c.startsWith(namePrefix))
    ?.substring(namePrefix.length) || '';
  return value ? decodeURIComponent(value) : null;
}

export interface UrlUtmData {
  page_url: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
}

export function captureUrlAndUtmData(): UrlUtmData {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;

  const data: UrlUtmData = {
    page_url: url.href,
  };

  // Capture UTM parameters if they exist
  const utmSource = searchParams.get("utm_source");
  if (utmSource) data.utm_source = utmSource;

  const utmMedium = searchParams.get("utm_medium");
  if (utmMedium) data.utm_medium = utmMedium;

  const utmCampaign = searchParams.get("utm_campaign");
  if (utmCampaign) data.utm_campaign = utmCampaign;

  const utmTerm = searchParams.get("utm_term");
  if (utmTerm) data.utm_term = utmTerm;

  const utmContent = searchParams.get("utm_content");
  if (utmContent) data.utm_content = utmContent;

  return data;
}

